import { Component, OnInit, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';

@Component({
    selector: 'app-awb-pieces',
    templateUrl: './awb-pieces.component.html',
    styleUrls: ['./awb-pieces.component.scss']
})

export class AwbPiecesComponent implements OnInit {
    @Input() piecesDetailsList: any;

    public isCollapsed = true;
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        flex: 1,
        minWidth: 120,
    };
    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 5,
        domLayout: 'autoHeight',

    }
    columnDefs = [
        { headerName: 'Child Awb', field: 'childawb' }
    ];

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    constructor(
        public activeModal: NgbActiveModal,
        private titleService: Title
    ) {
        titleService.setTitle('Air Way Bill');
     }

    ngOnInit() {
    }

}
